import { fetchEntities } from 'actions/entities'
import AddNewMenuItem from 'components/generics/AddNewMenuItem'
import NotificationsMenuItem from 'components/generics/NotificationsMenuItem'
import SearchMenuItem from 'components/generics/SearchMenuItem'
import OfficeSelector from 'components/offices/OfficeSelector'
import React from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { getCurrentEmployment } from 'selectors/employments'
import { Dropdown } from "semantic-ui-react";

import { Icon, Image, Menu } from 'semantic-ui-react'
import { setView } from "../../actions/view";
import building from 'images/building.svg'
import logo from 'images/zorgmee-logo.svg'

class MainMenu extends React.Component {
render () {
    return (
      <Menu color={this.props.color} className={'main-menu'} inverted>
        <Menu.Menu position='left'>
          <Menu.Item as='a' href={Routes.compass_path()}>
            <Image src={logo} alt='ZorgMee' size='small'/>
          </Menu.Item>
          <OfficeSelector/>
          {this.renderRoleSelector()}
        </Menu.Menu>
        <Menu.Menu position='right'>
          <AddNewMenuItem/>
          <SearchMenuItem/>
          <NotificationsMenuItem/>
          <Menu.Item as={NavLink} to={Routes.configuration_path()}>
            <Icon size="large" name="settings"/>
          </Menu.Item>
          <Menu.Item as='a' href={Routes.destroy_user_session_path()} data-method="delete" >
            <Icon size='large' name="sign out"/>
          </Menu.Item>
        </Menu.Menu>
      </Menu>
    )
  }

  renderRoleSelector() {
    if(!this.props.currentEmployment || !this.props.currentEmployment.user) {
      return null
    }

    const avatarSrc =  this.props.currentEmployment.photoUrl
    const userName = `${this.props.currentEmployment?.user?.firstName} ${this.props.currentEmployment?.user?.lastName}`

    const dropdownOptions = [
      {
        key: 'user',
        text: userName,
        value: 'user',
        image: { avatar: true, src: avatarSrc },
      },
      {
        key: 'admin',
        text: I18n.t('components.main_app.main_menu.admin'),
        value: 'admin',
        image: { avatar: true, src: building },
      },
    ]

    if(this.props.showAdmin && this.props.showPractitioner) {
      return (<Dropdown item options={dropdownOptions} defaultValue={this.props.view || 'user'}
                        onChange={(e, { value }) => this.props.setView(value)}/>)
    } else if(this.props.showAdmin){
      return <Menu.Item>
        <Image src={building} avatar spaced="right"/>
        {I18n.t('components.main_app.main_menu.admin')}
      </Menu.Item>
    } else {
      return <Menu.Item>
        <Image src={avatarSrc} avatar spaced="right"/>
        {userName}
      </Menu.Item>
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const current = getCurrentEmployment(state)
  const showAdmin = current && current.roles.includes('administrator')
  const showPractitioner = current && current.roles.includes('practitioner')

  return {
    currentEmployment: current,
    showAdmin: showAdmin,
    showPractitioner: showPractitioner,
    view: state.view
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch(fetchEntities('employments'))
      dispatch(fetchEntities('users'))
    },
    setView: (value) => {
      dispatch(setView(value))
      let extraParams = value === 'admin' ? {view: 'admin'}: {}
      window.location.href = Routes.compass_path(extraParams);
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu);
